export default __webpack_public_path__ + "static/media/main_logo.76c273c0.png";